
import { Component } from "react";
import * as React from 'react'
import { Col, Panel, Row } from 'react-bootstrap'
import * as ReactHighcharts from 'react-highcharts'
import { DataGrid } from 'app/components'
import { GIVTableDataSource } from 'app/containers/Home/DataSources'
import { GivIndexTable } from "../GivIndexTable";

interface IGivIndexProps {
  chartHeight: number
  titleFontSize: string
  displayClickHere?: boolean
}

interface IGivIndexState {
  trendTitle: string
  trendSubtitle: string
  givSeries: any[]
  sixtyFortySeries: any[]
  subtitleX: number
  subtitleY: number
  isLoggedIn: boolean
  apiKey: string
  username: string
  latestDataPeriod: string
}

export class GivIndex extends Component<IGivIndexProps, IGivIndexState> {
  state: IGivIndexState = {
    trendSubtitle: '',
    trendTitle: '',
    givSeries: [],
    sixtyFortySeries: [],
    subtitleX: -140,
    subtitleY: 475,
    isLoggedIn: false,
    apiKey: null,
    username: null,
    latestDataPeriod: '',
  }

  componentDidMount() {
    this.setTitleAndSubtitle()
    this.setSeries()
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    const { innerWidth: width } = window;
    let { subtitleX, subtitleY } = this.state
    if (width < 1024) {
      subtitleX = 75
      subtitleY = 400
    } else {
      subtitleX = -140
      subtitleY = 475
    }
    this.setState({ subtitleX, subtitleY });
  }

  public setTitleAndSubtitle() {
    const givTitleAndSubtitlePayload = { action: 'getGIVTrendTitleAndSubtitle', request: { assetLevel: 0, state: '', name: '', monthNumber: '12' } }
    fetch('https://r0okaqxkp2.execute-api.us-east-1.amazonaws.com/Test/foundationmark-requests', { method: 'POST', body: JSON.stringify(givTitleAndSubtitlePayload) })
      .then((response) => {
        return response.text()
      })
      .then((text) => {
        text = text.replace(/u0026/g, '&')
        text = text.replace(/\\/g, '')
        return JSON.parse(text)
      })
      .then((json) => {
        this.setState({ trendSubtitle: json.subtitleDate, trendTitle: json.titleDate, latestDataPeriod: json.latestMonthYear })
      })
  }

  public setSeries() {
    const givTrendFilterBody = { action: 'getGIVIndexTrend', request: { assetLevel: 0, state: '', name: '', monthNumber: '12' } }
    fetch('https://r0okaqxkp2.execute-api.us-east-1.amazonaws.com/Test/foundationmark-requests', { method: 'POST', body: JSON.stringify(givTrendFilterBody) })
      .then((response) => {
        return response.text()
      })
      .then((text) => {
        text = text.replace(/u0026/g, '&')
        text = text.replace(/\\/g, '')
        return JSON.parse(text)
      })
      .then((json) => {
        const givSeries = []
        const sixtyFortySeries = []
        for (const period of json) {
          const givPoint = { x: period.date, y: period.giv }
          const sixtyFortyPoint = { x: period.date, y: period.sixtyforty }
          givSeries.push(givPoint)
          sixtyFortySeries.push(sixtyFortyPoint)
        }

        sixtyFortySeries[sixtyFortySeries.length - 19] = {
          x: sixtyFortySeries[sixtyFortySeries.length - 19].x, y: sixtyFortySeries[sixtyFortySeries.length - 19].y, dataLabels: {
            enabled: true,
            align: 'right',
            x: 3,
            verticalAlign: 'top',
            overflow: true,
            crop: false,
            format: '{series.name}'
          },
        }

        givSeries[givSeries.length - 10] = {
          x: givSeries[givSeries.length - 10].x, y: givSeries[givSeries.length - 10].y, dataLabels: {
            enabled: true,
            align: 'right',
            x: 3,
            verticalAlign: 'top',
            overflow: true,
            crop: false,
            format: '{series.name}',
            style: {
              fontSize: '14px'
            }
          },
        }

        this.setState({ givSeries, sixtyFortySeries })
      })
  }

  public round(numberToRound: number, precision: number) {
    return (Math.round(numberToRound * 10) / 10).toFixed(precision)
  }

  public getGiveIndexConfig(trendTitle, trendSubtitle, giv, sixtyForty) {
    const { titleFontSize, displayClickHere } = this.props

    const title = displayClickHere ? '<b>Click <a style="color: #333" href="#/giv">here</a> for more interactive visualizations</b>' : ''


    return {
      chart: {
        type: 'line',
        height: this.props.chartHeight + '%',
      },
      title: {
        text: title,
        style: {
          "fontSize": '1.6rem',
          "color": "#00B050",
        },
        floating: true,
        x: 50,
        y: 100,
        align: 'left',
        useHTML: true,
      },
      xAxis: {
        type: 'datetime',
      },
      yAxis: {
        min: 50,
        title: null,
      },
      legend: {
        enabled: false,
      },
      credits: {
        enabled: false
      },
      plotOptions: {
        area: {
          marker: {
            enabled: false
          }
        }
      },
      tooltip: {
        headerFormat: '<b>{series.name}</b><br>',
        pointFormat: '',
      },
      series: [{
        name: 'GIV Index',
        colorByPoint: false,
        color: '#022636',
        fillOpacity: 0.10,
        lineColor: '#022636',
        lineWidth: 4,
        data: giv
      }, {
        name: '60/40 Index',
        colorByPoint: false,
        color: '#a1a1a1',
        dashStyle: 'ShortDash',
        fillOpacity: 0.10,
        lineColor: '#a1a1a1',
        data: sixtyForty,
        label: {
          enabled: true
        }
      }],
    }
  }

  render() {
    return (
      <section>
        {!this.props.displayClickHere && <header style={{ padding: "1rem" }}>GIV Index</header>}
        <ReactHighcharts config={this.getGiveIndexConfig(this.state.trendTitle, this.state.trendSubtitle, this.state.givSeries, this.state.sixtyFortySeries)} ref="chart" />
      </section>
    )
  }
}


// WEBPACK FOOTER //
// ./src/app/components/visualizations/GivIndex/index.tsx